import { CURRENCIES, ZERO_DECIMAL_CURRENCIES } from '@/lib/data/currencies';

export type CurrencyCode = string;

export function formatCurrency(amount: number, currencyCode: string): string {
  // Use Intl.NumberFormat which handles all valid ISO currency codes
  const isZeroDecimal = ZERO_DECIMAL_CURRENCIES.includes(currencyCode.toUpperCase() as any);
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: isZeroDecimal ? 0 : 2,
    maximumFractionDigits: isZeroDecimal ? 0 : 2,
  }).format(amount);
}

export function getCurrencySymbol(currencyCode: string): string {
  const currency = CURRENCIES.find(c => c.code === currencyCode);
  return currency?.symbol || currencyCode;
}

// For Stripe: Convert to smallest currency unit
export function toStripeAmount(amount: number, currencyCode: string): number {
  const isZeroDecimal = ZERO_DECIMAL_CURRENCIES.includes(currencyCode.toUpperCase() as any);
  if (isZeroDecimal) {
    return Math.round(amount); // Zero-decimal: no multiplication
  }
  return Math.round(amount * 100); // Standard: convert to cents
}

// From Stripe: Convert from smallest currency unit
export function fromStripeAmount(amount: number, currencyCode: string): number {
  const isZeroDecimal = ZERO_DECIMAL_CURRENCIES.includes(currencyCode.toUpperCase() as any);
  if (isZeroDecimal) {
    return amount; // Zero-decimal: no division
  }
  return amount / 100; // Standard: convert from cents
}
